import { Building } from "../Building";
import { PostManager } from "../post/PostManager";
import { MaterialManager } from "../../material/MaterialManager";

/**
 * Columns on the side of the building, works similarly as columns in LeanTo.
 */
export class SideColumns
{

	private _building : Building;

	private _leftPosts: PostManager;
	private _rightPosts: PostManager;

	private _visible: boolean = false;

	constructor(building: Building)
	{
		this._building = building;
		this.init();
	}

	private init = () =>
	{
		var material = MaterialManager.getInstance().trim;

		this._leftPosts = new PostManager(true, {
			material: material,
			noCorners: true
		});
		this._rightPosts = new PostManager(true, {
			material: material,
			noCorners: true
		});

		this._building.config.building.propertyChange.add(this.update);
		this._building.config.building.no_walls.signal.add(this.update);
		this._building.config.building.single_slope.signal.add(this.update);
		this.update();
	};

	private update = () =>
	{
		var no_walls = this._building.config.building.no_walls.value;

		if (no_walls)
		{
			// we only show side posts when no walls option is activated

			this.show();

			var metrics = this._building.config.metrics;

			var leftHeight  = metrics.height;
			var rightHeight = metrics.height;

			var single_slope = this._building.config.building.single_slope.value;

			var metrics = this._building.config.metrics;
			var heightAddition = metrics.tan * metrics.width - 0.2;

			// if (single_slope === "left")
			// {
			// 	leftHeight += heightAddition;
			// } else
			if (single_slope)
			{
				rightHeight += heightAddition;
			}

			this._leftPosts.update(metrics.length, leftHeight);
			this._leftPosts.container.position.x = - (metrics.width_half - PostManager.post_width);

			this._rightPosts.update(metrics.length, rightHeight);
			this._rightPosts.container.position.x = (metrics.width_half - PostManager.post_width);
		}
		else
		{
			this.hide();
		}
	}

	private show()
	{
		if (this._visible)
		{
			return;
		}

		var scene = this._building.scene3D;

		scene.add(this._leftPosts.container);
		scene.add(this._rightPosts.container);

		this._visible = true;
	}

	private hide()
	{
		if (!this._visible)
		{
			return;
		}

		var scene = this._building.scene3D;

		scene.remove(this._leftPosts.container);
		scene.remove(this._rightPosts.container);

		this._visible = false;
	}
}